import { NoteBlock } from "../types/notebook/note/block";
import { isSubscriptionBlock } from "../types/notebook/note/block/subscription";
import { Subscription } from "../types/subscription";
import { SubscriptionSearchResult } from "../types/subscriptionSearch";

export function pageSubscriptionOptions(
  blocks: NoteBlock[],
  subscriptionMap: Record<string, Subscription>,
): SubscriptionSearchResult[] {
  return blocks
    .filter(isSubscriptionBlock)
    .map((block) => {
      const subscription = subscriptionMap[block["sub-id"]];
      if (!subscription?.name) {
        return null;
      }

      return {
        name: subscription.name,
        "page-id": block["page-id"],
        "sub-id": block["sub-id"],
        "block-id": block["block-id"],
        subscription,
        block,
      };
    })
    .filter((value): value is SubscriptionSearchResult => value !== null);
}

export function mergeSubscriptionOptions(
  localOptions: SubscriptionSearchResult[],
  remoteOptions: SubscriptionSearchResult[],
): SubscriptionSearchResult[] {
  const merged = [...localOptions, ...remoteOptions];
  const seen = new Set<string>();

  return merged.filter((option) => {
    const key = `${option["page-id"]}:${option["block-id"]}:${option["sub-id"]}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}
